// @ts-check
import { useState } from 'react';
import { Tooltip } from '@material-ui/core';
import isEmpty from 'lodash/isEmpty';
import { StyledRepoText } from '../Notifications.style';
import { LBButton } from '@linearb/buzz';

const MAX_REPOS_ON_MESSAGE = 8;

const Description = ({ repositories }) => {
  const [showMore, setShowMore] = useState(false);
  const moreRepos = repositories.slice(MAX_REPOS_ON_MESSAGE);
  return (
    <>
      {repositories
        .slice(0, showMore ? repositories.length : MAX_REPOS_ON_MESSAGE)
        .map(({ name, http_url: httpUrl }, idx) => {
          const isLastItem = idx === repositories.length - 1;
          return (
            <Tooltip title={`${httpUrl}`} id='increaseTooltipZIndex' key={idx}>
              <StyledRepoText>
                {name}
                {!isLastItem && ', '}
              </StyledRepoText>
            </Tooltip>
          );
        })}
      {!isEmpty(moreRepos) && (
        <LBButton
          variant='ghost'
          onClick={() => setShowMore(prevState => !prevState)}
        >
          {showMore ? 'show less' : `show ${moreRepos.length} more`}
        </LBButton>
      )}
    </>
  );
};

export default Description;
